import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/auth/auth.service'; 
import { Observable, Subject } from 'rxjs';
import { BranchMatserService } from '../branch-matser.service';
import { SearchBranchMasterComponent } from '../search-branch-master/search-branch-master.component';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { CompanyMasterComponent } from '../Company-Setup/company-master/company-master.component';
@Component({
  selector: 'app-branch-master',
  templateUrl: './branch-master.component.html',
  styleUrls: ['./branch-master.component.scss']
})
export class BranchMasterComponent implements OnInit {
  branchdestroy$: Subject<boolean> = new Subject<boolean>();
  branchForm: FormGroup;
  SavingPayLoad: any =[];
  allState: any;
  public selectBranchObj: any = {};
  selectedId: number;
  selectedFile: File = null;
  filename: string = "No Files";
  filenotselected = true;
  stateIndex = [];
  folderName: string;
  uploadBtn: boolean;
  HospitalTypeName: any;
  HospitalCompanyId: any
  HospitalType: FormControl;
  filteredHospitalArray: Observable<any[]>;
  popbutton: number;

  constructor(public dialog: MatDialog, private _fb: FormBuilder, public branchMasterService: BranchMatserService,
    public snackBar: MatSnackBar, public http: HttpClient, public authservice: AuthService, private dialogRef: MatDialogRef<BranchMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    } 
    this.loadFormData();
    this.getStateList();
    this.folderName = 'HeaderImage';
    this.uploadBtn = true;
    this.HospitalTypeName = '';
    this.authservice.getcompanies();
    this.hospitalControll();
    this.getBrachMasterList();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })

  }

  setdoc_button() {}

  /**Reset the Form */
  loadFormData() {
    this.HospitalTypeName = null;
    this.uploadBtn = true;
    this.branchForm = this._fb.group({
      BranchName: ['', [Validators.required]],
      HospitalType: [null, [Validators.required]],
      BranchCode: ['', [Validators.required, Validators.maxLength(3)]],
      Address: '',
      ContactPerson: ['', [Validators.required]],
      ContactNo: ['', [Validators.required]],
      EmailAddress: ['', [Validators.required]],
      FaxNo: '',
      Line1: '',
      Line2: '',
      Line3: '',
      Line4: '',
      DLNO: '',
      TINNO: '',
      ImageLogo: '',
      IsNabhLogo: false,
      IsHeaderImage: false,
      HeaderImageHeight: '',
      HeaderImageWidth: '',
      GSTNo: '',
      PANNo: '',
      fkstateId: ['', [Validators.required]],
      isCentralOpticStore: 0,
      IsActive: false,
      PK_SynchId: null,
      PkBranchId: 0
    });
  }

  brancharray:any=[];
   getBrachMasterList() {
    this.branchMasterService.getBrachMasterList().subscribe(data => {
    this.brancharray = data;
    console.log(this.brancharray,'called branch array')
    })
    // console.log();
  }

  /** Save and Upload the Branch Master form */
  saveBrachForm(event) {
    // if (!this.HospitalCompanyId || this.HospitalCompanyId === undefined ||(!this.HospitalTypeName || !this.HospitalTypeName.trim())){
    //   this.openSnackBar("Please Select Hospital Name", "OK");
    //   return;
    // }
    const isValidHospital = this.authservice.Companies.some(hospital => hospital.companyName == this.HospitalTypeName);
    if (!this.HospitalCompanyId || !isValidHospital || !this.HospitalTypeName?.trim()) {
      this.openSnackBar("Please Select a Valid Hospital Name", "OK");
      return;
    }

    if (this.branchForm.controls.BranchName.value == "") {
      this.openSnackBar("Please Select Branch Name ", "OK");
      return;
    }

  const enteredBranchName = this.branchForm.controls.BranchName.value.trim().toLowerCase();
  const isDuplicate = this.brancharray.some(branch => 
  branch.branchName.trim().toLowerCase() === enteredBranchName &&
  branch.pkBranchId !== this.branchForm.controls.PkBranchId.value
);
if (isDuplicate) {
  this.openSnackBar("Branch Name already exists", "OK");
  return;
}

// Branch combination with Company....name
// const enteredBranchName = this.branchForm.controls.BranchName.value.trim().toLowerCase();
// const selectedCompanyId = this.HospitalCompanyId;

// const isDuplicate = this.brancharray.some(branch => 
//   branch.branchName.trim().toLowerCase() === enteredBranchName &&
//   branch.fK_CompanyId === selectedCompanyId && 
//   branch.pkBranchId !== this.branchForm.controls.PkBranchId.value
// );

// if (isDuplicate) {
//   this.openSnackBar("Branch Name already exists", "OK");
//   return;
// }


    if (this.branchForm.controls.BranchCode.value == "") {
      this.openSnackBar("Please Select Branch Code ", "OK");
      return;
    }
    if (this.branchForm.controls.fkstateId.value == "") {
      this.openSnackBar("Please Select State ", "OK");
      return;
    }
    if (this.branchForm.controls.ContactPerson.value == "") {
      this.openSnackBar("Please Select Contact Person ", "OK");
      return;
    }
    if (this.branchForm.controls.ContactNo.value == "") {
      this.openSnackBar("Please Select Contact No ", "OK");
      return;
    }
    const contactNo = this.branchForm.controls.ContactNo.value;
    if (contactNo.length < 10 || contactNo.length > 10) {
      this.openSnackBar("Contact No must be exactly 10 digits", "OK");
      return;
    }
    if (this.branchForm.controls.EmailAddress.value == "") {
      this.openSnackBar("Please Select Email Address ", "OK");
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.branchForm.controls.EmailAddress.value)) {
      this.openSnackBar("Please Select valid Email Address Format", "OK");
      return;
    }
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);

    this.SavingPayLoad = [];
    const form = this.branchForm.controls;
    if (form.IsHeaderImage.value === true) {
      this.uploadBtn = false;
    } else {
      this.uploadBtn = true;
    }
    let stateName = this.allState.filter(item => item.pkStateId == form.fkstateId.value);
    this.SavingPayLoad = {
      // pkBranchId: 0,
      address: form.Address.value,
      branchCode: form.BranchCode.value,
      branchName: form.BranchName.value,
      contactNo: form.ContactNo.value,
      contactPerson: form.ContactPerson.value,
      dlno: form.DLNO.value,
      emailAddress: form.EmailAddress.value,
      faxNo: form.FaxNo.value,
      fkstateId: form.fkstateId.value,
      stateName: stateName[0].stateName,
      gstNo: form.GSTNo.value,
      headerImageHeight: form.HeaderImageHeight.value,
      headerImageWidth: form.HeaderImageWidth.value,
      imageLogo: form.ImageLogo.value,
      isActive: form.IsActive.value,
      isCentralOpticStore: form.isCentralOpticStore.value,
      isHeaderImage: form.IsHeaderImage.value,
      isNabhLogo: form.IsNabhLogo.value,
      line1: form.Line1.value,
      line2: form.Line2.value,
      line3: form.Line3.value,
      line4: form.Line4.value,
      panNo: form.PANNo.value,
      tinno: form.TINNO.value,
      pkBranchId: form.PkBranchId.value,
      // fK_CompanyId: form.HospitalType['id'],
      fK_CompanyId: this.HospitalCompanyId,
      pK_SynchId: null,
      gstCode: null,
      printCode: null,
      geoLocation: null,
      weburl: null,
      centralStores: null
    }

    if (this.SavingPayLoad.isCentralOpticStore === true || this.SavingPayLoad.isCentralOpticStore == '1') {
      this.SavingPayLoad.isCentralOpticStore = 1;
    } else {
      this.SavingPayLoad.isCentralOpticStore = 0;
    }
    if (this.SavingPayLoad.imageLogo === true || this.SavingPayLoad.imageLogo == 'Y') {
      this.SavingPayLoad.ImageLogo = 'Y';
    } else {
      this.SavingPayLoad.ImageLogo = 'N';
    }
    if (form.PkBranchId.value == 0) {
      delete this.SavingPayLoad.PkBranchId;
      this.branchMasterService.addBranchMaster(this.SavingPayLoad).pipe(takeUntil(this.branchdestroy$)).subscribe(data => {
        if(data['statusCode'] == 10){
          this.openSnackBar("This record is already exists","OK");
        }else{
          this.openSnackBar("Record Saved Successfully", "OK");
          this.loadFormData();
        }
      },err =>{
         button.removeAttribute('disabled');
        if (err.status == 403) {
          this.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.openSnackBar(err.error.message, "OK");
        }
        else {
          this.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.branchMasterService.addBranchMaster(this.SavingPayLoad).pipe(takeUntil(this.branchdestroy$)).subscribe(data => {
        if(data['statusCode'] == 10){
          this.openSnackBar("This record is already exists","OK");
        }else{
          this.openSnackBar("Record Updated Successfully", "OK");
          this.loadFormData();
        }
      },err =>{
         button.removeAttribute('disabled');
        if (err.status == 403) {
          this.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.openSnackBar(err.error.message, "OK");
        }
        else {
          this.openSnackBar("API Failed", "OK");
        }
      });
    }
  }

  /** Seach Branch Master */
  searchBrachMaster() {
    const dialogRef1 = this.dialog.open(SearchBranchMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "80%",
    });

    dialogRef1.afterClosed().subscribe(result => {
      this.selectBranchObj = this.branchMasterService.selecteBranchMasterData
      if (this.selectBranchObj != null) {
        this.selectedId = this.selectBranchObj.pkBranchId;
        this.HospitalCompanyId = this.selectBranchObj.fK_CompanyId;
        this.setupdateBranchMasterForm(this.selectedId);
      }
    });
  }

  setupdateBranchMasterForm(id) {
    this.branchMasterService.getBrachMasterItem(id).pipe(takeUntil(this.branchdestroy$)).subscribe(data => {
      let selectedBranch = data[0];
      this.branchForm.patchValue(
        {
          Address: selectedBranch.address,
          BranchCode: selectedBranch.branchCode,
          BranchName: selectedBranch.branchName,
          ContactNo: selectedBranch.contactNo,
          ContactPerson: selectedBranch.contactPerson,
          DLNO: selectedBranch.dlno,
          EmailAddress: selectedBranch.emailAddress,
          FaxNo: selectedBranch.faxNo,
          fkstateId: selectedBranch.fkstateId,
          GSTNo: selectedBranch.gstNo,
          HeaderImageHeight: selectedBranch.headerImageHeight,
          HeaderImageWidth: selectedBranch.headerImageWidth,
          ImageLogo: selectedBranch.imageLogo == 'Y' ? true : false,
          IsActive: selectedBranch.isActive,
          isCentralOpticStore: selectedBranch.isCentralOpticStore,
          IsHeaderImage: selectedBranch.isHeaderImage,
          IsNabhLogo: selectedBranch.isNabhLogo,
          Line1: selectedBranch.line1,
          Line2: selectedBranch.line2,
          Line3: selectedBranch.line3,
          Line4: selectedBranch.line4,
          // PK_SynchId: selectedBranch.pK_SynchId,
          PANNo: selectedBranch.panNo,
          TINNO: selectedBranch.tinno,
          PkBranchId: selectedBranch.pkBranchId,
          HospitalType: selectedBranch.companyName,
        });
      if (selectedBranch.isHeaderImage == true) {
        this.uploadBtn = false;
      } else {
        this.uploadBtn = true;
      }
    });
  }

  //autocomplete
  hospitalControll() {
    this.HospitalType = new FormControl();
    this.filteredHospitalArray = this.HospitalType.valueChanges
      .pipe(startWith(''),
        map(item => item ? this.filterHtypefunction(item) : this.authservice.Companies.slice())
      );
  }

  filterHtypefunction(name: string) {
    return this.authservice.Companies.filter(item =>
      item.companyName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }


  hospitalObj(event) {
    this.branchForm.controls.HospitalType = event.option;
    this.HospitalTypeName = event.option.value;
    this.HospitalCompanyId = event.option.id
  }

  /* Get State APi */
  getStateList() {
    this.branchMasterService.getState().pipe(takeUntil(this.branchdestroy$)).subscribe(data => {
      let stateListActive = data;
      for (var _i = 0; _i < stateListActive.length; _i++) {
        if (stateListActive[_i].isActive == true) {
          this.stateIndex.push(stateListActive[_i]);
          this.allState = this.stateIndex;
        }
      }
    });
  }


  selectImageLog(event: MatCheckboxChange) {
    if (event.checked === true) {
      this.uploadBtn = false;
    } else {
      this.uploadBtn = true;
    }
  }

  /** Image upload */
  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    this.filename = this.selectedFile.name;
    this.upLoadFile();
  }

  upLoadFile() {
    let fileToUpload = this.selectedFile;
    const formData = new FormData();
    formData.append('file', fileToUpload);
    formData.append('documentname', this.filename);
    formData.append('patientid', '420');
    formData.append('branchId', '1');
    formData.append('FolderNameMain', this.folderName);
    this.http.post(this.branchMasterService.newbaseUrl + "Document" + "/UploadFile", formData).subscribe(data => {
      this.openSnackBar(this.selectedFile.name + " Uploaded Successfully", "OK");
    });
  }

  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  letterOnly(event) {

    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 46 || charCode == 32)

      return true;
    else
      return false;
  }

  ngOnDestroy() {
    this.branchdestroy$.next(true);
    this.branchdestroy$.unsubscribe();
  }
  closedailog() {
    this.dialogRef.close();
  }
  

}